
import { recentChatTabModel } from '../../models/model';
import { Types }from '../action/action';

const initialState = {
    tabcontactDetail: {},
    tabcontact: {},
    tabrecentindex: 0
  };

  
  export const recentChatTabReducer = (state:recentChatTabModel = initialState, action: any) => {
    const {
      type,
      payloads
    } = action;
    switch (type) {
    case Types.TAB_CONTENT_DETAILS:
    return {
      ...state, tabcontactDetail: payloads.tabcontactDetail, tabcontact: payloads.tabcontact, tabrecentindex: payloads.tabrecentindex
    };
    default:
      return state;
    };
  };